import Title from '@/components/Title';
export default {
  components: {
    Title
  },
  props: {
    itemcls: Boolean,
    title: {
      type: String,
      default: '产品优势'
    },
    adslist: {
      type: Array,
      required: true
    }
  }
};